module.exports = __webpack_public_path__ + "static/img/ttr06.b622d87.png";